import React from 'react';
import { InputProps } from 'antd';

import {
  StyledAntdInput,
  StyledAntdTextArea,
} from './style';

const CVInput = (props: InputProps): JSX.Element => (
  <StyledAntdInput {...props} />
);

CVInput.TextArea = StyledAntdTextArea;

export default CVInput;
